

import React, { memo } from 'react';
import cx from 'classnames';
import Files from 'react-files';
import { Icon, Text } from '../../../ui-kit';

import '../styles/_asset-dropzone.scss';

const MIN_FILE_SIZE = 1;
const FILE_SIZE_MULTIPLIER = 10000000000;
const MAX_FILE_SIZE_GB = 10 * FILE_SIZE_MULTIPLIER;















const AssetDropzone = ({
  filesRef,
  clickable,
  accepts,
  className,
  showInfoOnDrag,
  title,
  subtitle,
  dragTitle,
  minFileSize = MIN_FILE_SIZE,
  maxFileSize = MAX_FILE_SIZE_GB,
  onChange
}) => {
  const wrapperClassNames = cx(
    'asset-dropzone',
    className
  );

  return (
    <div className={wrapperClassNames}>
      <Files
        className="asset-dropzone__area"
        dropActiveClassName="asset-dropzone__active"
        ref={filesRef}
        onChange={onChange}
        clickable={clickable}
        minFileSize={minFileSize}
        maxFileSize={maxFileSize}
        accepts={accepts}>

        <div className="asset-dropzone__content">
          <Icon name="importI" color="regent" size={40} />

          <div className="asset-dropzone__text">
            <Text className="asset-dropzone__title" heading4 noMargin>
              {title}
            </Text>

            <Text body success noMargin>{subtitle}</Text>
          </div>
        </div>

        {
        showInfoOnDrag &&
        <div className="asset-dropzone__drag-info">
              <Text className="asset-dropzone__drag-label" centered noMargin>
                Drop files here to upload them to
              </Text>

              <Text centered heading5 noMargin>{dragTitle}</Text>
            </div>}


      </Files>
    </div>);

};

export default memo(AssetDropzone);